import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta05 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-05/utils-consultaSeguimentoPergunta05'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMchatExemplosPassouFalhouTableItem } from '../components/HistoricoMchatExemplosPassouFalhouTableItem'
import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta05 } from './converter-HistoricoMchatPergunta05'

interface HistoricoMChatRfPergunta05Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta05 = (props: Readonly<HistoricoMChatRfPergunta05Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta05(aplicacoes)
  if (converted == null) return null

  const { header, exemplosPassou, exemplosFalhou, perguntaFrequencia, model } = converted
  if (header === null) return null

  const resultado = calculateResultadoPergunta05(model)
  const hasExemplos = exemplosPassou.isNotEmpty() || exemplosFalhou.isNotEmpty()
  const exibirPergunta = header.stPassou ? '“Por favor, descreva esses movimentos.”' : undefined

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='5'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta={exibirPergunta}
      />
      {hasExemplos && (
        <HistoricoMchatExemplosPassouFalhouTableItem exemplosPassou={exemplosPassou} exemplosFalhou={exemplosFalhou} />
      )}
      {perguntaFrequencia && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={[perguntaFrequencia]} />}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
